import angular from 'angular';

angular.module('digitalPayments', []);

angular.module('digitalPayments').config(["$translatePartialLoaderProvider", function($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('digital_payments');

    /* Add New States Above */

}]);